module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-purple-7c042ea67b8938883adaa820a2a73561.svg";